<template>
  <div class="load" v-show="isShow">
    <div class="loading">
      <div style="--x: 0"></div>
      <div style="--x: 1"></div>
      <div style="--x: 2"></div>
      <div style="--x: 3"></div>
      <div style="--x: 4"></div>
      <div style="--x: 5"></div>
    </div>
    <div class="timeout_box" v-show="timeOut">
      <!-- 请求超时  点击返回首页 -->
      {{$t("common.t1")}} <a href="./">{{$t("common.t2")}} </a>

    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      isShow: false,
      timeOut: false,
    };
  },

  mounted() {
    // this.fn1(2);
  },
  methods: {
    show() {
      this.isShow = true;
      this.timeOut = false;
      let that = this;

      setTimeout(function () {
        that.timeOut = true;
      }, 30000);
    },
    hide() {
      this.isShow = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/css/_common.scss";
.load {
  z-index: 1000;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //玻璃质感
  background-color: $c-glass;
  backdrop-filter: $d-glass;
  border-bottom: $b-glass;
  // transition: all 0.3s;
}
.loading {
  z-index: 999;
  display: flex;
  /* 水平显示 */
  flex-direction: row;
}

.loading div {
  position: relative;
  width: 1.2rem;
  height: 8rem;
  //   background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), $c-lightblue);
  //玻璃质感
  background-color: $c-glass;
  backdrop-filter: $d-glass;
  border-bottom: $b-glass;

  margin: 0.5rem;
  border-radius: 20px;
  border: $b-border;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1), -2px -2px 4px rgb(255, 225, 220),
    inset -2px -2px 4px rgba(255, 255, 255, 0.5),
    inset 2px 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.loading div::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  box-shadow: inset -2px -5px 5px rgba(0, 0, 0, 0.05),
    0 410px 0 400px rgba(241, 76, 43, 0.2);
  animation: animate 2s ease-in-out infinite;
  animation-delay: calc(var(--x) * 0.3s);
  transform: translateY(8rem);
}

@keyframes animate {
  0% {
    transform: translateY(7rem);
    filter: hue-rotate(0deg);
  }

  50% {
    transform: translateY(0rem);
    filter: hue-rotate(-20deg);
  }

  100% {
    transform: translateY(7rem);
    filter: hue-rotate(-40deg);
  }
}

.timeout_box {
  position: absolute;
  margin-top: 12rem;
  font-size: $f-min;
  cursor: pointer;
  a {
    //  margin-left: $m-mid;
    color: $c-main;
    text-decoration: none;
    //  border: $b-border;
    //  padding: $m-lit;
    //  border-radius: $r-lit;
    //  box-shadow: $shadow;
  }
}
</style>
